// src/components/analytics/RedemptionRateChart.js
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const RedemptionRateChart = ({ dateRange, selectedProgram, granularity }) => {
    // Mock data for redemption rate
    const generateData = () => {
        const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
        const redemptionRates = [65, 68, 70, 72, 70, 75]; // As percentage

        return {
            labels: labels,
            datasets: [
                {
                    label: 'Redemption Rate (%)',
                    data: redemptionRates,
                    borderColor: 'rgb(251, 191, 36)', // Amber-400
                    backgroundColor: 'rgba(251, 191, 36, 0.2)',
                    fill: false,
                    tension: 0.3,
                },
            ],
        };
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: { family: 'Inter, sans-serif' },
                    color: '#374151',
                },
            },
            title: {
                display: false,
            },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                bodyFont: { family: 'Inter, sans-serif' },
                titleFont: { family: 'Inter, sans-serif', weight: 'bold' },
                callbacks: {
                    label: function(context) {
                        let label = context.dataset.label || '';
                        if (label) {
                            label += ': ';
                        }
                        label += context.raw + '%';
                        return label;
                    }
                }
            }
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    color: '#4b5563',
                    font: { family: 'Inter, sans-serif' }
                },
            },
            y: {
                beginAtZero: true,
                max: 100,
                grid: {
                    color: 'rgba(209, 213, 219, 0.4)',
                },
                ticks: {
                    color: '#4b5563',
                    font: { family: 'Inter, sans-serif' },
                    callback: function(value) {
                        return value + '%';
                    }
                },
            },
        },
    };

    return (
        <div className="bg-white rounded-lg shadow-md p-6 h-96 flex flex-col">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Redemption Rate Trend</h3>
            <p className="text-sm text-gray-500 mb-4">Percentage of issued points that are redeemed.</p>
            <div className="flex-1 relative">
                <Line data={generateData()} options={options} />
            </div>
        </div>
    );
};

export default RedemptionRateChart;